import { useEffect } from 'react'

export default function Contact() {
  useEffect(() => {
    document.title = 'Send an Environmental Equipment RFQ | Grace Wang'
  }, [])

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    alert('Form submitted! In production, this will send an email to gracewang.environmental@gmail.com')
  }

  return (
    <div className="contact-page">
      <section className="page-header">
        <p className="eyebrow">WRITTEN INQUIRY FIRST</p>
        <h1>Send Your Project Requirements</h1>
        <p>Email your available project information, technical specifications or drawings for an initial review of the equipment supply scope.</p>
        <p>Technical meetings are scheduled after the initial project scope has been reviewed in writing, so the right people can join with the right information.</p>
      </section>

      <section className="contact-content">
        <div className="contact-info">
          <h2>Direct Email</h2>
          <p><a href="mailto:gracewang.environmental@gmail.com">gracewang.environmental@gmail.com</a></p>

          <h2>What to Include</h2>
          <ol className="checklist">
            <li>Company name and project country</li>
            <li>Application or industry</li>
            <li>Required capacity, flow or airflow</li>
            <li>Main contaminants and known concentrations</li>
            <li>Required outlet limit or applicable local standard</li>
            <li>Required equipment scope</li>
            <li>Preferred materials</li>
            <li>Available layouts, specifications or equipment drawings</li>
            <li>Destination and target schedule</li>
          </ol>
          <p><strong>Suggested email subject:</strong> Environmental Equipment RFQ – [Company Name] – [Project Country]</p>
        </div>

        <div className="contact-form-section">
          <h2>RFQ Form</h2>
          <form onSubmit={handleSubmit} className="rfq-form">
            <div className="form-group">
              <label htmlFor="company">Company Name</label>
              <input type="text" id="company" name="company" required />
            </div>
            <div className="form-group">
              <label htmlFor="country">Project Country</label>
              <input type="text" id="country" name="country" required />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" name="email" required />
            </div>
            <div className="form-group">
              <label htmlFor="industry">Application or Industry</label>
              <input type="text" id="industry" name="industry" />
            </div>
            <div className="form-group">
              <label htmlFor="capacity">Required Capacity / Flow / Airflow</label>
              <input type="text" id="capacity" name="capacity" />
            </div>
            <div className="form-group">
              <label htmlFor="contaminants">Main Contaminants</label>
              <input type="text" id="contaminants" name="contaminants" />
            </div>
            <div className="form-group">
              <label htmlFor="scope">Required Equipment Scope</label>
              <textarea id="scope" name="scope" rows={4}></textarea>
            </div>
            <div className="form-group">
              <label htmlFor="materials">Preferred Materials</label>
              <input type="text" id="materials" name="materials" />
            </div>
            <div className="form-group">
              <label htmlFor="schedule">Target Schedule</label>
              <input type="text" id="schedule" name="schedule" />
            </div>
            <div className="form-group">
              <label htmlFor="message">Additional Information</label>
              <textarea id="message" name="message" rows={4}></textarea>
            </div>
            <button type="submit" className="btn-primary">Send RFQ</button>
          </form>
          <p className="form-note">Equipment configuration, supply scope, pricing, lead time, inspection documentation and commercial terms are confirmed on a project-specific basis.</p>
        </div>
      </section>
    </div>
  )
}
